import React from 'react';
import PropTypes from 'prop-types';
import DayPicker from '../DayPicker';
import { DateTimeFormatters } from '../../../../sc-intl';

const IntlDayPicker = props => {
    const {
        monthNames,
        weekdayNames,
        weekdayShortNames,
        weekStartIndex,
    } = DateTimeFormatters;

    return (
        <DayPicker
            locale={props.locale}
            months={monthNames(props.locale)}
            weekdaysLong={weekdayNames(props.locale)}
            weekdaysShort={weekdayShortNames(props.locale)}
            firstDayOfWeek={weekStartIndex(props.locale)}
            navbarElement={<Navbar />}
            {...props}
        />
    );
};

function Navbar({
    showPreviousButton,
    showNextButton,
    onPreviousClick,
    onNextClick,
  }) {
    return (
      <div className="DayPicker__navigation">
        <button onClick={() => onPreviousClick()} className={`DayPicker-NavButton DayPicker-NavButton--prev button--clear ${showPreviousButton ? "show-nav-button" : "hide-nav-button"}`}>
            <i className="icon-navigate_before"><span className="sr-only">Previous Month</span></i>
        </button>
        <button onClick={() => onNextClick()} className={`DayPicker-NavButton DayPicker-NavButton--next button--clear ${showNextButton ? "show-nav-button" : "hide-nav-button"}`}>
            <i className="icon-navigate_next"><span className="sr-only">Next Month</span></i>
        </button>
      </div>
    );
  }

IntlDayPicker.propTypes = {
    locale: PropTypes.string.isRequired,
    selectedDay: PropTypes.string,
    startingMonth: PropTypes.instanceOf(Date),
    endingMonth: PropTypes.instanceOf(Date),
    selectedDays: PropTypes.array.isRequired,
    disabledDays: PropTypes.array,
    onDayClick: PropTypes.func.isRequired,
    onMonthChange: PropTypes.func.isRequired,
};

export default IntlDayPicker;
